// extracted by mini-css-extract-plugin
export default {"Form":"CommentCreateEditForm_Form__QvcqY","Button":"CommentCreateEditForm_Button__Q6E4k"};